module.exports = __webpack_public_path__ + "static/media/616.4b30b109.png";